module.exports = __webpack_public_path__ + "img/Walls_text01_opaque.4f5a4e37.png";